var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343,
    height: 60,
    viewBox: "0 0 343 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plan_selected",
    transform: "translate(-25 -846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1126",
    "data-name": "Rectangle 1126",
    transform: "translate(25 846)",
    fill: "#fff",
    stroke: "#49a8fb",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 341,
    height: 58,
    rx: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22033",
    "data-name": "Path 22033",
    transform: "translate(230 846)",
    fill: "#e5f1fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 128 59 L 0.6204206943511963 59 L -13.88196182250977 29.74252700805664 L 0.6156144738197327 1 L 128 1 C 132.9626159667969 1 137 5.037380218505859 137 10 L 137 50 C 137 54.96261978149414 132.9626159667969 59 128 59 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.231231689453125 2 L -12.763916015625 29.74642944335938 L 1.240852355957031 58 L 128 58 C 132.4112091064453 58 136 54.41120910644531 136 50 L 136 10 C 136 5.588790893554688 132.4112091064453 2 128 2 L 1.231231689453125 2 M 0 0 L 128 0 C 133.5228271484375 0 138 4.477146148681641 138 10 L 138 50 C 138 55.52285385131836 133.5228271484375 60 128 60 L 0 60 L -15 29.73862457275391 L 0 0 Z",
    stroke: "none",
    fill: "#e5f1fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1183",
    "data-name": "Rectangle 1183",
    transform: "translate(25 846)",
    fill: "none",
    stroke: "#49a8fb",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 341,
    height: 58,
    rx: 9,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanSelected);
export default __webpack_public_path__ + "static/media/plan_selected.1d3fa8aefe1c7a13be4458940bbe9ae4.svg";
export { ForwardRef as ReactComponent };